import { render, staticRenderFns } from "./editParameter.vue?vue&type=template&id=ebf42dba"
import script from "./editParameter.vue?vue&type=script&lang=js"
export * from "./editParameter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports